import React from 'react';
import Grid from '@material-ui/core/Grid';

const styles = {
  footer: {
    height: '6vh',
    width: '100%',
    background: '#001a33',
    overflow: 'hidden',
  },
  footerMobile: {
    paddingTop: 10,
    paddingBottom: 10,
    width: '100%',
    background: '#001a33',
  },
  top: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '70%',
    alignItems: 'center',
    padding: 10,
  },
  socialButtons: {
    height: 30,
    marginLeft: 10,
    marginRight: 10,
  },
  bottom: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 570,
    padding: 20,
    paddingTop: 10,
  },
  logo: {
    height: 30,
    marginBottom: 20,
  },
  whiteText: {
    color: 'lightgray',
    textAlign: 'center',
  },
  divider: {
    borderBottom: '2px solid rgb(99, 173, 221)',
    width: '80%',
    margin: 10,
  },
  navButtons: {
    display: 'flex',
    marginBottom: 10,
  },
  linkButton: {
    textDecoration: 'none',
    color: '#AAA',
    fontSize: '0.875rem',
  },
  bottomButtons: {
    color: 'lightgray',
  },
  socials: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '50px',
  },
  support_links: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  copyright: {
    display: 'flex',
    justifyContent: 'center',
  },
  links: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
};

const Footer = (props) => {
  const { width } = props;
  const isMobile = width < 850;
  if (!isMobile)
    return (
      <div style={styles.footer}>
        <Grid
          container
          spacing={0}
          style={{ alignItems: 'center', height: '100%' }}
        >
          <Grid item xs={12} md={3}>
            <div style={styles.copyright}>
              <a style={styles.linkButton}>Powered by CBOE LiveVol</a>
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div style={styles.copyright}>
              <a style={styles.linkButton}>
                Copyright 2024 OptionsGeek. All Rights Reserved.
              </a>
            </div>
          </Grid>
          <Grid item xs={12} md={3}>
            <div style={styles.support_links}>
              <a
                href="https://optionsgeek.com/disclaimer/"
                style={styles.linkButton}
              >
                Disclaimer
              </a>
              <a
                href="https://optionsgeek.com/terms-conditions/"
                style={styles.linkButton}
              >
                Terms & Conditions
              </a>
              <a
                href="https://optionsgeek.com/privacy-policy/"
                style={styles.linkButton}
              >
                Privacy Policy
              </a>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  return <div>footer</div>;
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js